import logo from './logo.svg';
import './App.css';
import { Landing } from './Component/Screen';

function App() {
  return (
    <div>
      <Landing/>
  
    </div>
  );
}

export default App;
